module.exports = __webpack_public_path__ + "static/img/iconshipin_guanbi_24_hei.02b62a4e.png";